/* tslint:disable */
/* eslint-disable */
/**
 * Pitango Market API
 * Canonical public and administrative HTTP API contract.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
    AdminGetProductsOrderByCols,
    AdminOrderDirection,
    AdminProductsPayloadIApplyGoogleProductImageRequest,
    AdminProductsPayloadIBulkSetActiveRequest,
    AdminProductsPayloadIBulkSetOutOfStockRequest,
    AdminProductsPayloadICreateProductRequest,
    AdminProductsPayloadISearchGoogleProductImagesRequest,
    AdminProductsPayloadISetProductActiveRequest,
    AdminProductsPayloadISetProductOutOfStockRequest,
    AdminProductsPayloadISetProductSyncLocksRequest,
    AdminProductsPayloadISetProductUserTypePricesRequest,
    AdminProductsPayloadIUpdateProductRequest,
    AdminProductsPayloadIUpsertProductTranslateRequest,
    AdminProductsResponseApplyGoogleProductImageResponse,
    AdminProductsResponseBulkSetActiveResponse,
    AdminProductsResponseBulkSetOutOfStockResponse,
    AdminProductsResponseCreateProductResponse,
    AdminProductsResponseDeleteProductImageResponse,
    AdminProductsResponseDeleteProductTranslateResponse,
    AdminProductsResponseGetProductImagesResponse,
    AdminProductsResponseGetProductTranslationsResponse,
    AdminProductsResponseGetProductUserTypePricesResponse,
    AdminProductsResponseGetProductsResponse,
    AdminProductsResponseGetUserTypeProductPricesResponse,
    AdminProductsResponseLinkProductCategoryResponse,
    AdminProductsResponseSearchGoogleProductImagesResponse,
    AdminProductsResponseSetProductActiveResponse,
    AdminProductsResponseSetProductDefaultImageResponse,
    AdminProductsResponseSetProductOutOfStockResponse,
    AdminProductsResponseSetProductSyncLocksResponse,
    AdminProductsResponseSetProductUserTypePricesResponse,
    AdminProductsResponseUnlinkProductCategoryResponse,
    AdminProductsResponseUpdateProductResponse,
    AdminProductsResponseUploadProductImageResponse,
    AdminProductsResponseUpsertProductTranslateResponse,
    ApiErrorEnvelope,
    LanguageCode,
    ProductsRequestGetProductPricesRequest,
    ProductsResponseGetProductDetailsResponse,
    ProductsResponseGetProductPricesResponse,
    ProductsResponseGetProductsResponse,
    ProductsResponseGetPromotedProductsResponse,
    ProductsResponseGetTopProductsResponse,
    ProductsResponseSearchProductsResponse,
} from '../models/index';

export interface AdminProductsApplyGoogleProductImageRequest {
    productId: string;
    adminProductsPayloadIApplyGoogleProductImageRequest: AdminProductsPayloadIApplyGoogleProductImageRequest;
}

export interface AdminProductsBulkSetActiveRequest {
    adminProductsPayloadIBulkSetActiveRequest: AdminProductsPayloadIBulkSetActiveRequest;
}

export interface AdminProductsBulkSetOutOfStockRequest {
    adminProductsPayloadIBulkSetOutOfStockRequest: AdminProductsPayloadIBulkSetOutOfStockRequest;
}

export interface AdminProductsCreateProductRequest {
    adminProductsPayloadICreateProductRequest: AdminProductsPayloadICreateProductRequest;
}

export interface AdminProductsDeleteProductImageRequest {
    productId: string;
    productImageId: string;
}

export interface AdminProductsDeleteProductTranslateRequest {
    productId: string;
    languageCode: LanguageCode;
}

export interface AdminProductsGetProductImagesRequest {
    productId: string;
}

export interface AdminProductsGetProductTranslationsRequest {
    productId: string;
}

export interface AdminProductsGetProductUserTypePricesRequest {
    productId: string;
}

export interface AdminProductsGetProductsRequest {
    languageCode?: string;
    pageIndex?: number;
    pageSize?: number;
    categoryId?: string;
    categoryIds?: Array<string>;
    q?: string;
    productId?: string;
    externalId?: number;
    barcode?: string;
    barcodeExact?: string;
    identifier?: string;
    identifierExact?: string;
    active?: boolean;
    outOfStock?: boolean;
    priceMin?: number;
    priceMax?: number;
    createdFrom?: string;
    createdTo?: string;
    modifiedFrom?: string;
    modifiedTo?: string;
    syncedFrom?: string;
    syncedTo?: string;
    hasImage?: boolean;
    barcodeIsNull?: boolean;
    imageFileIsNull?: boolean;
    promotionPriceIsNull?: boolean;
    sortBy?: AdminGetProductsOrderByCols;
    sortDir?: AdminOrderDirection;
}

export interface AdminProductsGetUserTypeProductPricesRequest {
    userTypeId: string;
}

export interface AdminProductsLinkProductCategoryRequest {
    productId: string;
    categoryId: string;
}

export interface AdminProductsSearchGoogleProductImagesRequest {
    productId: string;
    adminProductsPayloadISearchGoogleProductImagesRequest: AdminProductsPayloadISearchGoogleProductImagesRequest;
}

export interface AdminProductsSetProductActiveRequest {
    productId: string;
    adminProductsPayloadISetProductActiveRequest: AdminProductsPayloadISetProductActiveRequest;
}

export interface AdminProductsSetProductDefaultImageRequest {
    productId: string;
    productImageId: string;
}

export interface AdminProductsSetProductOutOfStockRequest {
    productId: string;
    adminProductsPayloadISetProductOutOfStockRequest: AdminProductsPayloadISetProductOutOfStockRequest;
}

export interface AdminProductsSetProductSyncLocksRequest {
    productId: string;
    adminProductsPayloadISetProductSyncLocksRequest: AdminProductsPayloadISetProductSyncLocksRequest;
}

export interface AdminProductsSetProductUserTypePricesRequest {
    productId: string;
    adminProductsPayloadISetProductUserTypePricesRequest: AdminProductsPayloadISetProductUserTypePricesRequest;
}

export interface AdminProductsUnlinkProductCategoryRequest {
    productId: string;
    categoryId: string;
}

export interface AdminProductsUpdateProductRequest {
    productId: string;
    adminProductsPayloadIUpdateProductRequest: AdminProductsPayloadIUpdateProductRequest;
}

export interface AdminProductsUploadProductImageRequest {
    productId: string;
    image: Blob;
    setAsDefault?: boolean;
}

export interface AdminProductsUpsertProductTranslateRequest {
    productId: string;
    languageCode: LanguageCode;
    adminProductsPayloadIUpsertProductTranslateRequest: AdminProductsPayloadIUpsertProductTranslateRequest;
}

export interface ProductsGetProductDetailsRequest {
    languageCode: LanguageCode;
    productRef: string;
}

export interface ProductsGetProductImageRequest {
    imageFile: string;
}

export interface ProductsGetProductPricesRequest {
    productsRequestGetProductPricesRequest: ProductsRequestGetProductPricesRequest;
}

export interface ProductsGetProductsRequest {
    languageCode: LanguageCode;
    categoryId: string;
    pageIndex: number;
}

export interface ProductsGetProductsWithoutOptionalParameterRequest {
    languageCode: LanguageCode;
    categoryId: string;
}

export interface ProductsGetPromotedProductsRequest {
    languageCode: LanguageCode;
    pageIndex: number;
}

export interface ProductsGetPromotedProductsWithoutOptionalParameterRequest {
    languageCode: LanguageCode;
}

export interface ProductsGetTopProductsRequest {
    languageCode: LanguageCode;
    limit: number;
}

export interface ProductsGetTopProductsWithoutOptionalParameterRequest {
    languageCode: LanguageCode;
}

export interface ProductsSearchProductsRequest {
    searchTerm: string;
}

/**
 *
 */
export class ProductsApi extends runtime.BaseAPI {

    /**
     * Creates request options for adminProductsApplyGoogleProductImage without sending the request
     */
    async adminProductsApplyGoogleProductImageRequestOpts(requestParameters: AdminProductsApplyGoogleProductImageRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['productId'] == null) {
            throw new runtime.RequiredError(
                'productId',
                'Required parameter "productId" was null or undefined when calling adminProductsApplyGoogleProductImage().'
            );
        }

        if (requestParameters['adminProductsPayloadIApplyGoogleProductImageRequest'] == null) {
            throw new runtime.RequiredError(
                'adminProductsPayloadIApplyGoogleProductImageRequest',
                'Required parameter "adminProductsPayloadIApplyGoogleProductImageRequest" was null or undefined when calling adminProductsApplyGoogleProductImage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/products/{productId}/images/google/apply`;
        urlPath = urlPath.replace('{productId}', encodeURIComponent(String(requestParameters['productId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['adminProductsPayloadIApplyGoogleProductImageRequest'],
        };
    }

    /**
     * Apply Google Product Image
     */
    async adminProductsApplyGoogleProductImageRaw(requestParameters: AdminProductsApplyGoogleProductImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProductsResponseApplyGoogleProductImageResponse>> {
        const requestOptions = await this.adminProductsApplyGoogleProductImageRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Apply Google Product Image
     */
    async adminProductsApplyGoogleProductImage(requestParameters: AdminProductsApplyGoogleProductImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProductsResponseApplyGoogleProductImageResponse> {
        const response = await this.adminProductsApplyGoogleProductImageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminProductsBulkSetActive without sending the request
     */
    async adminProductsBulkSetActiveRequestOpts(requestParameters: AdminProductsBulkSetActiveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['adminProductsPayloadIBulkSetActiveRequest'] == null) {
            throw new runtime.RequiredError(
                'adminProductsPayloadIBulkSetActiveRequest',
                'Required parameter "adminProductsPayloadIBulkSetActiveRequest" was null or undefined when calling adminProductsBulkSetActive().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/products/bulk/active`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['adminProductsPayloadIBulkSetActiveRequest'],
        };
    }

    /**
     * Bulk Set Active
     */
    async adminProductsBulkSetActiveRaw(requestParameters: AdminProductsBulkSetActiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProductsResponseBulkSetActiveResponse>> {
        const requestOptions = await this.adminProductsBulkSetActiveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Bulk Set Active
     */
    async adminProductsBulkSetActive(requestParameters: AdminProductsBulkSetActiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProductsResponseBulkSetActiveResponse> {
        const response = await this.adminProductsBulkSetActiveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminProductsBulkSetOutOfStock without sending the request
     */
    async adminProductsBulkSetOutOfStockRequestOpts(requestParameters: AdminProductsBulkSetOutOfStockRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['adminProductsPayloadIBulkSetOutOfStockRequest'] == null) {
            throw new runtime.RequiredError(
                'adminProductsPayloadIBulkSetOutOfStockRequest',
                'Required parameter "adminProductsPayloadIBulkSetOutOfStockRequest" was null or undefined when calling adminProductsBulkSetOutOfStock().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/products/bulk/out-of-stock`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['adminProductsPayloadIBulkSetOutOfStockRequest'],
        };
    }

    /**
     * Bulk Set Out Of Stock
     */
    async adminProductsBulkSetOutOfStockRaw(requestParameters: AdminProductsBulkSetOutOfStockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProductsResponseBulkSetOutOfStockResponse>> {
        const requestOptions = await this.adminProductsBulkSetOutOfStockRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Bulk Set Out Of Stock
     */
    async adminProductsBulkSetOutOfStock(requestParameters: AdminProductsBulkSetOutOfStockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProductsResponseBulkSetOutOfStockResponse> {
        const response = await this.adminProductsBulkSetOutOfStockRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminProductsCreateProduct without sending the request
     */
    async adminProductsCreateProductRequestOpts(requestParameters: AdminProductsCreateProductRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['adminProductsPayloadICreateProductRequest'] == null) {
            throw new runtime.RequiredError(
                'adminProductsPayloadICreateProductRequest',
                'Required parameter "adminProductsPayloadICreateProductRequest" was null or undefined when calling adminProductsCreateProduct().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/products`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['adminProductsPayloadICreateProductRequest'],
        };
    }

    /**
     * Create Product
     */
    async adminProductsCreateProductRaw(requestParameters: AdminProductsCreateProductRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProductsResponseCreateProductResponse>> {
        const requestOptions = await this.adminProductsCreateProductRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Create Product
     */
    async adminProductsCreateProduct(requestParameters: AdminProductsCreateProductRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProductsResponseCreateProductResponse> {
        const response = await this.adminProductsCreateProductRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminProductsDeleteProductImage without sending the request
     */
    async adminProductsDeleteProductImageRequestOpts(requestParameters: AdminProductsDeleteProductImageRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['productId'] == null) {
            throw new runtime.RequiredError(
                'productId',
                'Required parameter "productId" was null or undefined when calling adminProductsDeleteProductImage().'
            );
        }

        if (requestParameters['productImageId'] == null) {
            throw new runtime.RequiredError(
                'productImageId',
                'Required parameter "productImageId" was null or undefined when calling adminProductsDeleteProductImage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/admin/products/{productId}/images/{productImageId}`;
        urlPath = urlPath.replace('{productId}', encodeURIComponent(String(requestParameters['productId'])));
        urlPath = urlPath.replace('{productImageId}', encodeURIComponent(String(requestParameters['productImageId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete Product Image
     */
    async adminProductsDeleteProductImageRaw(requestParameters: AdminProductsDeleteProductImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProductsResponseDeleteProductImageResponse>> {
        const requestOptions = await this.adminProductsDeleteProductImageRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Delete Product Image
     */
    async adminProductsDeleteProductImage(requestParameters: AdminProductsDeleteProductImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProductsResponseDeleteProductImageResponse> {
        const response = await this.adminProductsDeleteProductImageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminProductsDeleteProductTranslate without sending the request
     */
    async adminProductsDeleteProductTranslateRequestOpts(requestParameters: AdminProductsDeleteProductTranslateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['productId'] == null) {
            throw new runtime.RequiredError(
                'productId',
                'Required parameter "productId" was null or undefined when calling adminProductsDeleteProductTranslate().'
            );
        }

        if (requestParameters['languageCode'] == null) {
            throw new runtime.RequiredError(
                'languageCode',
                'Required parameter "languageCode" was null or undefined when calling adminProductsDeleteProductTranslate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/admin/products/{productId}/translations/{languageCode}`;
        urlPath = urlPath.replace('{productId}', encodeURIComponent(String(requestParameters['productId'])));
        urlPath = urlPath.replace('{languageCode}', encodeURIComponent(String(requestParameters['languageCode'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete Product Translate
     */
    async adminProductsDeleteProductTranslateRaw(requestParameters: AdminProductsDeleteProductTranslateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProductsResponseDeleteProductTranslateResponse>> {
        const requestOptions = await this.adminProductsDeleteProductTranslateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Delete Product Translate
     */
    async adminProductsDeleteProductTranslate(requestParameters: AdminProductsDeleteProductTranslateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProductsResponseDeleteProductTranslateResponse> {
        const response = await this.adminProductsDeleteProductTranslateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminProductsGetProductImages without sending the request
     */
    async adminProductsGetProductImagesRequestOpts(requestParameters: AdminProductsGetProductImagesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['productId'] == null) {
            throw new runtime.RequiredError(
                'productId',
                'Required parameter "productId" was null or undefined when calling adminProductsGetProductImages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/admin/products/{productId}/images`;
        urlPath = urlPath.replace('{productId}', encodeURIComponent(String(requestParameters['productId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Product Images
     */
    async adminProductsGetProductImagesRaw(requestParameters: AdminProductsGetProductImagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProductsResponseGetProductImagesResponse>> {
        const requestOptions = await this.adminProductsGetProductImagesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get Product Images
     */
    async adminProductsGetProductImages(requestParameters: AdminProductsGetProductImagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProductsResponseGetProductImagesResponse> {
        const response = await this.adminProductsGetProductImagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminProductsGetProductTranslations without sending the request
     */
    async adminProductsGetProductTranslationsRequestOpts(requestParameters: AdminProductsGetProductTranslationsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['productId'] == null) {
            throw new runtime.RequiredError(
                'productId',
                'Required parameter "productId" was null or undefined when calling adminProductsGetProductTranslations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/admin/products/{productId}/translations`;
        urlPath = urlPath.replace('{productId}', encodeURIComponent(String(requestParameters['productId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Product Translations
     */
    async adminProductsGetProductTranslationsRaw(requestParameters: AdminProductsGetProductTranslationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProductsResponseGetProductTranslationsResponse>> {
        const requestOptions = await this.adminProductsGetProductTranslationsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get Product Translations
     */
    async adminProductsGetProductTranslations(requestParameters: AdminProductsGetProductTranslationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProductsResponseGetProductTranslationsResponse> {
        const response = await this.adminProductsGetProductTranslationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminProductsGetProductUserTypePrices without sending the request
     */
    async adminProductsGetProductUserTypePricesRequestOpts(requestParameters: AdminProductsGetProductUserTypePricesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['productId'] == null) {
            throw new runtime.RequiredError(
                'productId',
                'Required parameter "productId" was null or undefined when calling adminProductsGetProductUserTypePrices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/admin/products/{productId}/user-type-prices`;
        urlPath = urlPath.replace('{productId}', encodeURIComponent(String(requestParameters['productId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Product User Type Prices
     */
    async adminProductsGetProductUserTypePricesRaw(requestParameters: AdminProductsGetProductUserTypePricesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProductsResponseGetProductUserTypePricesResponse>> {
        const requestOptions = await this.adminProductsGetProductUserTypePricesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get Product User Type Prices
     */
    async adminProductsGetProductUserTypePrices(requestParameters: AdminProductsGetProductUserTypePricesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProductsResponseGetProductUserTypePricesResponse> {
        const response = await this.adminProductsGetProductUserTypePricesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminProductsGetProducts without sending the request
     */
    async adminProductsGetProductsRequestOpts(requestParameters: AdminProductsGetProductsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['languageCode'] != null) {
            queryParameters['languageCode'] = requestParameters['languageCode'];
        }

        if (requestParameters['pageIndex'] != null) {
            queryParameters['pageIndex'] = requestParameters['pageIndex'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['categoryId'] != null) {
            queryParameters['categoryId'] = requestParameters['categoryId'];
        }

        if (requestParameters['categoryIds'] != null) {
            queryParameters['categoryIds'] = requestParameters['categoryIds'];
        }

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['productId'] != null) {
            queryParameters['productId'] = requestParameters['productId'];
        }

        if (requestParameters['externalId'] != null) {
            queryParameters['externalId'] = requestParameters['externalId'];
        }

        if (requestParameters['barcode'] != null) {
            queryParameters['barcode'] = requestParameters['barcode'];
        }

        if (requestParameters['barcodeExact'] != null) {
            queryParameters['barcodeExact'] = requestParameters['barcodeExact'];
        }

        if (requestParameters['identifier'] != null) {
            queryParameters['identifier'] = requestParameters['identifier'];
        }

        if (requestParameters['identifierExact'] != null) {
            queryParameters['identifierExact'] = requestParameters['identifierExact'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        if (requestParameters['outOfStock'] != null) {
            queryParameters['outOfStock'] = requestParameters['outOfStock'];
        }

        if (requestParameters['priceMin'] != null) {
            queryParameters['priceMin'] = requestParameters['priceMin'];
        }

        if (requestParameters['priceMax'] != null) {
            queryParameters['priceMax'] = requestParameters['priceMax'];
        }

        if (requestParameters['createdFrom'] != null) {
            queryParameters['createdFrom'] = requestParameters['createdFrom'];
        }

        if (requestParameters['createdTo'] != null) {
            queryParameters['createdTo'] = requestParameters['createdTo'];
        }

        if (requestParameters['modifiedFrom'] != null) {
            queryParameters['modifiedFrom'] = requestParameters['modifiedFrom'];
        }

        if (requestParameters['modifiedTo'] != null) {
            queryParameters['modifiedTo'] = requestParameters['modifiedTo'];
        }

        if (requestParameters['syncedFrom'] != null) {
            queryParameters['syncedFrom'] = requestParameters['syncedFrom'];
        }

        if (requestParameters['syncedTo'] != null) {
            queryParameters['syncedTo'] = requestParameters['syncedTo'];
        }

        if (requestParameters['hasImage'] != null) {
            queryParameters['hasImage'] = requestParameters['hasImage'];
        }

        if (requestParameters['barcodeIsNull'] != null) {
            queryParameters['barcodeIsNull'] = requestParameters['barcodeIsNull'];
        }

        if (requestParameters['imageFileIsNull'] != null) {
            queryParameters['imageFileIsNull'] = requestParameters['imageFileIsNull'];
        }

        if (requestParameters['promotionPriceIsNull'] != null) {
            queryParameters['promotionPriceIsNull'] = requestParameters['promotionPriceIsNull'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortDir'] != null) {
            queryParameters['sortDir'] = requestParameters['sortDir'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/admin/products`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Products
     */
    async adminProductsGetProductsRaw(requestParameters: AdminProductsGetProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProductsResponseGetProductsResponse>> {
        const requestOptions = await this.adminProductsGetProductsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get Products
     */
    async adminProductsGetProducts(requestParameters: AdminProductsGetProductsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProductsResponseGetProductsResponse> {
        const response = await this.adminProductsGetProductsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminProductsGetUserTypeProductPrices without sending the request
     */
    async adminProductsGetUserTypeProductPricesRequestOpts(requestParameters: AdminProductsGetUserTypeProductPricesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userTypeId'] == null) {
            throw new runtime.RequiredError(
                'userTypeId',
                'Required parameter "userTypeId" was null or undefined when calling adminProductsGetUserTypeProductPrices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/admin/user-types/{userTypeId}/product-prices`;
        urlPath = urlPath.replace('{userTypeId}', encodeURIComponent(String(requestParameters['userTypeId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get User Type Product Prices
     */
    async adminProductsGetUserTypeProductPricesRaw(requestParameters: AdminProductsGetUserTypeProductPricesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProductsResponseGetUserTypeProductPricesResponse>> {
        const requestOptions = await this.adminProductsGetUserTypeProductPricesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get User Type Product Prices
     */
    async adminProductsGetUserTypeProductPrices(requestParameters: AdminProductsGetUserTypeProductPricesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProductsResponseGetUserTypeProductPricesResponse> {
        const response = await this.adminProductsGetUserTypeProductPricesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminProductsLinkProductCategory without sending the request
     */
    async adminProductsLinkProductCategoryRequestOpts(requestParameters: AdminProductsLinkProductCategoryRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['productId'] == null) {
            throw new runtime.RequiredError(
                'productId',
                'Required parameter "productId" was null or undefined when calling adminProductsLinkProductCategory().'
            );
        }

        if (requestParameters['categoryId'] == null) {
            throw new runtime.RequiredError(
                'categoryId',
                'Required parameter "categoryId" was null or undefined when calling adminProductsLinkProductCategory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/admin/products/{productId}/categories/{categoryId}`;
        urlPath = urlPath.replace('{productId}', encodeURIComponent(String(requestParameters['productId'])));
        urlPath = urlPath.replace('{categoryId}', encodeURIComponent(String(requestParameters['categoryId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Link Product Category
     */
    async adminProductsLinkProductCategoryRaw(requestParameters: AdminProductsLinkProductCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProductsResponseLinkProductCategoryResponse>> {
        const requestOptions = await this.adminProductsLinkProductCategoryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Link Product Category
     */
    async adminProductsLinkProductCategory(requestParameters: AdminProductsLinkProductCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProductsResponseLinkProductCategoryResponse> {
        const response = await this.adminProductsLinkProductCategoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminProductsSearchGoogleProductImages without sending the request
     */
    async adminProductsSearchGoogleProductImagesRequestOpts(requestParameters: AdminProductsSearchGoogleProductImagesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['productId'] == null) {
            throw new runtime.RequiredError(
                'productId',
                'Required parameter "productId" was null or undefined when calling adminProductsSearchGoogleProductImages().'
            );
        }

        if (requestParameters['adminProductsPayloadISearchGoogleProductImagesRequest'] == null) {
            throw new runtime.RequiredError(
                'adminProductsPayloadISearchGoogleProductImagesRequest',
                'Required parameter "adminProductsPayloadISearchGoogleProductImagesRequest" was null or undefined when calling adminProductsSearchGoogleProductImages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/products/{productId}/images/google/search`;
        urlPath = urlPath.replace('{productId}', encodeURIComponent(String(requestParameters['productId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['adminProductsPayloadISearchGoogleProductImagesRequest'],
        };
    }

    /**
     * Search Google Product Images
     */
    async adminProductsSearchGoogleProductImagesRaw(requestParameters: AdminProductsSearchGoogleProductImagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProductsResponseSearchGoogleProductImagesResponse>> {
        const requestOptions = await this.adminProductsSearchGoogleProductImagesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Search Google Product Images
     */
    async adminProductsSearchGoogleProductImages(requestParameters: AdminProductsSearchGoogleProductImagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProductsResponseSearchGoogleProductImagesResponse> {
        const response = await this.adminProductsSearchGoogleProductImagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminProductsSetProductActive without sending the request
     */
    async adminProductsSetProductActiveRequestOpts(requestParameters: AdminProductsSetProductActiveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['productId'] == null) {
            throw new runtime.RequiredError(
                'productId',
                'Required parameter "productId" was null or undefined when calling adminProductsSetProductActive().'
            );
        }

        if (requestParameters['adminProductsPayloadISetProductActiveRequest'] == null) {
            throw new runtime.RequiredError(
                'adminProductsPayloadISetProductActiveRequest',
                'Required parameter "adminProductsPayloadISetProductActiveRequest" was null or undefined when calling adminProductsSetProductActive().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/products/{productId}/active`;
        urlPath = urlPath.replace('{productId}', encodeURIComponent(String(requestParameters['productId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['adminProductsPayloadISetProductActiveRequest'],
        };
    }

    /**
     * Set Product Active
     */
    async adminProductsSetProductActiveRaw(requestParameters: AdminProductsSetProductActiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProductsResponseSetProductActiveResponse>> {
        const requestOptions = await this.adminProductsSetProductActiveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Set Product Active
     */
    async adminProductsSetProductActive(requestParameters: AdminProductsSetProductActiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProductsResponseSetProductActiveResponse> {
        const response = await this.adminProductsSetProductActiveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminProductsSetProductDefaultImage without sending the request
     */
    async adminProductsSetProductDefaultImageRequestOpts(requestParameters: AdminProductsSetProductDefaultImageRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['productId'] == null) {
            throw new runtime.RequiredError(
                'productId',
                'Required parameter "productId" was null or undefined when calling adminProductsSetProductDefaultImage().'
            );
        }

        if (requestParameters['productImageId'] == null) {
            throw new runtime.RequiredError(
                'productImageId',
                'Required parameter "productImageId" was null or undefined when calling adminProductsSetProductDefaultImage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/admin/products/{productId}/images/{productImageId}/default`;
        urlPath = urlPath.replace('{productId}', encodeURIComponent(String(requestParameters['productId'])));
        urlPath = urlPath.replace('{productImageId}', encodeURIComponent(String(requestParameters['productImageId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Set Product Default Image
     */
    async adminProductsSetProductDefaultImageRaw(requestParameters: AdminProductsSetProductDefaultImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProductsResponseSetProductDefaultImageResponse>> {
        const requestOptions = await this.adminProductsSetProductDefaultImageRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Set Product Default Image
     */
    async adminProductsSetProductDefaultImage(requestParameters: AdminProductsSetProductDefaultImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProductsResponseSetProductDefaultImageResponse> {
        const response = await this.adminProductsSetProductDefaultImageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminProductsSetProductOutOfStock without sending the request
     */
    async adminProductsSetProductOutOfStockRequestOpts(requestParameters: AdminProductsSetProductOutOfStockRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['productId'] == null) {
            throw new runtime.RequiredError(
                'productId',
                'Required parameter "productId" was null or undefined when calling adminProductsSetProductOutOfStock().'
            );
        }

        if (requestParameters['adminProductsPayloadISetProductOutOfStockRequest'] == null) {
            throw new runtime.RequiredError(
                'adminProductsPayloadISetProductOutOfStockRequest',
                'Required parameter "adminProductsPayloadISetProductOutOfStockRequest" was null or undefined when calling adminProductsSetProductOutOfStock().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/products/{productId}/out-of-stock`;
        urlPath = urlPath.replace('{productId}', encodeURIComponent(String(requestParameters['productId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['adminProductsPayloadISetProductOutOfStockRequest'],
        };
    }

    /**
     * Set Product Out Of Stock
     */
    async adminProductsSetProductOutOfStockRaw(requestParameters: AdminProductsSetProductOutOfStockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProductsResponseSetProductOutOfStockResponse>> {
        const requestOptions = await this.adminProductsSetProductOutOfStockRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Set Product Out Of Stock
     */
    async adminProductsSetProductOutOfStock(requestParameters: AdminProductsSetProductOutOfStockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProductsResponseSetProductOutOfStockResponse> {
        const response = await this.adminProductsSetProductOutOfStockRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminProductsSetProductSyncLocks without sending the request
     */
    async adminProductsSetProductSyncLocksRequestOpts(requestParameters: AdminProductsSetProductSyncLocksRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['productId'] == null) {
            throw new runtime.RequiredError(
                'productId',
                'Required parameter "productId" was null or undefined when calling adminProductsSetProductSyncLocks().'
            );
        }

        if (requestParameters['adminProductsPayloadISetProductSyncLocksRequest'] == null) {
            throw new runtime.RequiredError(
                'adminProductsPayloadISetProductSyncLocksRequest',
                'Required parameter "adminProductsPayloadISetProductSyncLocksRequest" was null or undefined when calling adminProductsSetProductSyncLocks().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/products/{productId}/sync-locks`;
        urlPath = urlPath.replace('{productId}', encodeURIComponent(String(requestParameters['productId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['adminProductsPayloadISetProductSyncLocksRequest'],
        };
    }

    /**
     * Set Product Sync Locks
     */
    async adminProductsSetProductSyncLocksRaw(requestParameters: AdminProductsSetProductSyncLocksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProductsResponseSetProductSyncLocksResponse>> {
        const requestOptions = await this.adminProductsSetProductSyncLocksRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Set Product Sync Locks
     */
    async adminProductsSetProductSyncLocks(requestParameters: AdminProductsSetProductSyncLocksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProductsResponseSetProductSyncLocksResponse> {
        const response = await this.adminProductsSetProductSyncLocksRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminProductsSetProductUserTypePrices without sending the request
     */
    async adminProductsSetProductUserTypePricesRequestOpts(requestParameters: AdminProductsSetProductUserTypePricesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['productId'] == null) {
            throw new runtime.RequiredError(
                'productId',
                'Required parameter "productId" was null or undefined when calling adminProductsSetProductUserTypePrices().'
            );
        }

        if (requestParameters['adminProductsPayloadISetProductUserTypePricesRequest'] == null) {
            throw new runtime.RequiredError(
                'adminProductsPayloadISetProductUserTypePricesRequest',
                'Required parameter "adminProductsPayloadISetProductUserTypePricesRequest" was null or undefined when calling adminProductsSetProductUserTypePrices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/products/{productId}/user-type-prices`;
        urlPath = urlPath.replace('{productId}', encodeURIComponent(String(requestParameters['productId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['adminProductsPayloadISetProductUserTypePricesRequest'],
        };
    }

    /**
     * Set Product User Type Prices
     */
    async adminProductsSetProductUserTypePricesRaw(requestParameters: AdminProductsSetProductUserTypePricesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProductsResponseSetProductUserTypePricesResponse>> {
        const requestOptions = await this.adminProductsSetProductUserTypePricesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Set Product User Type Prices
     */
    async adminProductsSetProductUserTypePrices(requestParameters: AdminProductsSetProductUserTypePricesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProductsResponseSetProductUserTypePricesResponse> {
        const response = await this.adminProductsSetProductUserTypePricesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminProductsUnlinkProductCategory without sending the request
     */
    async adminProductsUnlinkProductCategoryRequestOpts(requestParameters: AdminProductsUnlinkProductCategoryRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['productId'] == null) {
            throw new runtime.RequiredError(
                'productId',
                'Required parameter "productId" was null or undefined when calling adminProductsUnlinkProductCategory().'
            );
        }

        if (requestParameters['categoryId'] == null) {
            throw new runtime.RequiredError(
                'categoryId',
                'Required parameter "categoryId" was null or undefined when calling adminProductsUnlinkProductCategory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/admin/products/{productId}/categories/{categoryId}`;
        urlPath = urlPath.replace('{productId}', encodeURIComponent(String(requestParameters['productId'])));
        urlPath = urlPath.replace('{categoryId}', encodeURIComponent(String(requestParameters['categoryId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Unlink Product Category
     */
    async adminProductsUnlinkProductCategoryRaw(requestParameters: AdminProductsUnlinkProductCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProductsResponseUnlinkProductCategoryResponse>> {
        const requestOptions = await this.adminProductsUnlinkProductCategoryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Unlink Product Category
     */
    async adminProductsUnlinkProductCategory(requestParameters: AdminProductsUnlinkProductCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProductsResponseUnlinkProductCategoryResponse> {
        const response = await this.adminProductsUnlinkProductCategoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminProductsUpdateProduct without sending the request
     */
    async adminProductsUpdateProductRequestOpts(requestParameters: AdminProductsUpdateProductRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['productId'] == null) {
            throw new runtime.RequiredError(
                'productId',
                'Required parameter "productId" was null or undefined when calling adminProductsUpdateProduct().'
            );
        }

        if (requestParameters['adminProductsPayloadIUpdateProductRequest'] == null) {
            throw new runtime.RequiredError(
                'adminProductsPayloadIUpdateProductRequest',
                'Required parameter "adminProductsPayloadIUpdateProductRequest" was null or undefined when calling adminProductsUpdateProduct().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/products/{productId}`;
        urlPath = urlPath.replace('{productId}', encodeURIComponent(String(requestParameters['productId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['adminProductsPayloadIUpdateProductRequest'],
        };
    }

    /**
     * Update Product
     */
    async adminProductsUpdateProductRaw(requestParameters: AdminProductsUpdateProductRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProductsResponseUpdateProductResponse>> {
        const requestOptions = await this.adminProductsUpdateProductRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Update Product
     */
    async adminProductsUpdateProduct(requestParameters: AdminProductsUpdateProductRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProductsResponseUpdateProductResponse> {
        const response = await this.adminProductsUpdateProductRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminProductsUploadProductImage without sending the request
     */
    async adminProductsUploadProductImageRequestOpts(requestParameters: AdminProductsUploadProductImageRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['productId'] == null) {
            throw new runtime.RequiredError(
                'productId',
                'Required parameter "productId" was null or undefined when calling adminProductsUploadProductImage().'
            );
        }

        if (requestParameters['image'] == null) {
            throw new runtime.RequiredError(
                'image',
                'Required parameter "image" was null or undefined when calling adminProductsUploadProductImage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['image'] != null) {
            formParams.append('image', requestParameters['image'] as any);
        }

        if (requestParameters['setAsDefault'] != null) {
            formParams.append('setAsDefault', requestParameters['setAsDefault'] as any);
        }


        let urlPath = `/admin/products/{productId}/images`;
        urlPath = urlPath.replace('{productId}', encodeURIComponent(String(requestParameters['productId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        };
    }

    /**
     * Upload Product Image
     */
    async adminProductsUploadProductImageRaw(requestParameters: AdminProductsUploadProductImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProductsResponseUploadProductImageResponse>> {
        const requestOptions = await this.adminProductsUploadProductImageRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Upload Product Image
     */
    async adminProductsUploadProductImage(requestParameters: AdminProductsUploadProductImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProductsResponseUploadProductImageResponse> {
        const response = await this.adminProductsUploadProductImageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for adminProductsUpsertProductTranslate without sending the request
     */
    async adminProductsUpsertProductTranslateRequestOpts(requestParameters: AdminProductsUpsertProductTranslateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['productId'] == null) {
            throw new runtime.RequiredError(
                'productId',
                'Required parameter "productId" was null or undefined when calling adminProductsUpsertProductTranslate().'
            );
        }

        if (requestParameters['languageCode'] == null) {
            throw new runtime.RequiredError(
                'languageCode',
                'Required parameter "languageCode" was null or undefined when calling adminProductsUpsertProductTranslate().'
            );
        }

        if (requestParameters['adminProductsPayloadIUpsertProductTranslateRequest'] == null) {
            throw new runtime.RequiredError(
                'adminProductsPayloadIUpsertProductTranslateRequest',
                'Required parameter "adminProductsPayloadIUpsertProductTranslateRequest" was null or undefined when calling adminProductsUpsertProductTranslate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/products/{productId}/translations/{languageCode}`;
        urlPath = urlPath.replace('{productId}', encodeURIComponent(String(requestParameters['productId'])));
        urlPath = urlPath.replace('{languageCode}', encodeURIComponent(String(requestParameters['languageCode'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['adminProductsPayloadIUpsertProductTranslateRequest'],
        };
    }

    /**
     * Upsert Product Translate
     */
    async adminProductsUpsertProductTranslateRaw(requestParameters: AdminProductsUpsertProductTranslateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProductsResponseUpsertProductTranslateResponse>> {
        const requestOptions = await this.adminProductsUpsertProductTranslateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Upsert Product Translate
     */
    async adminProductsUpsertProductTranslate(requestParameters: AdminProductsUpsertProductTranslateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProductsResponseUpsertProductTranslateResponse> {
        const response = await this.adminProductsUpsertProductTranslateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for productsGetProductDetails without sending the request
     */
    async productsGetProductDetailsRequestOpts(requestParameters: ProductsGetProductDetailsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['languageCode'] == null) {
            throw new runtime.RequiredError(
                'languageCode',
                'Required parameter "languageCode" was null or undefined when calling productsGetProductDetails().'
            );
        }

        if (requestParameters['productRef'] == null) {
            throw new runtime.RequiredError(
                'productRef',
                'Required parameter "productRef" was null or undefined when calling productsGetProductDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/products/{languageCode}/{productRef}/details`;
        urlPath = urlPath.replace('{languageCode}', encodeURIComponent(String(requestParameters['languageCode'])));
        urlPath = urlPath.replace('{productRef}', encodeURIComponent(String(requestParameters['productRef'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Product Details
     */
    async productsGetProductDetailsRaw(requestParameters: ProductsGetProductDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductsResponseGetProductDetailsResponse>> {
        const requestOptions = await this.productsGetProductDetailsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get Product Details
     */
    async productsGetProductDetails(requestParameters: ProductsGetProductDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductsResponseGetProductDetailsResponse> {
        const response = await this.productsGetProductDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for productsGetProductImage without sending the request
     */
    async productsGetProductImageRequestOpts(requestParameters: ProductsGetProductImageRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['imageFile'] == null) {
            throw new runtime.RequiredError(
                'imageFile',
                'Required parameter "imageFile" was null or undefined when calling productsGetProductImage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/products/images/{imageFile}`;
        urlPath = urlPath.replace('{imageFile}', encodeURIComponent(String(requestParameters['imageFile'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Product Image
     */
    async productsGetProductImageRaw(requestParameters: ProductsGetProductImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const requestOptions = await this.productsGetProductImageRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Get Product Image
     */
    async productsGetProductImage(requestParameters: ProductsGetProductImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.productsGetProductImageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for productsGetProductPrices without sending the request
     */
    async productsGetProductPricesRequestOpts(requestParameters: ProductsGetProductPricesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['productsRequestGetProductPricesRequest'] == null) {
            throw new runtime.RequiredError(
                'productsRequestGetProductPricesRequest',
                'Required parameter "productsRequestGetProductPricesRequest" was null or undefined when calling productsGetProductPrices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/products/prices`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['productsRequestGetProductPricesRequest'],
        };
    }

    /**
     * Get Product Prices
     */
    async productsGetProductPricesRaw(requestParameters: ProductsGetProductPricesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductsResponseGetProductPricesResponse>> {
        const requestOptions = await this.productsGetProductPricesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get Product Prices
     */
    async productsGetProductPrices(requestParameters: ProductsGetProductPricesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductsResponseGetProductPricesResponse> {
        const response = await this.productsGetProductPricesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for productsGetProducts without sending the request
     */
    async productsGetProductsRequestOpts(requestParameters: ProductsGetProductsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['languageCode'] == null) {
            throw new runtime.RequiredError(
                'languageCode',
                'Required parameter "languageCode" was null or undefined when calling productsGetProducts().'
            );
        }

        if (requestParameters['categoryId'] == null) {
            throw new runtime.RequiredError(
                'categoryId',
                'Required parameter "categoryId" was null or undefined when calling productsGetProducts().'
            );
        }

        if (requestParameters['pageIndex'] == null) {
            throw new runtime.RequiredError(
                'pageIndex',
                'Required parameter "pageIndex" was null or undefined when calling productsGetProducts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/products/{languageCode}/{categoryId}/{pageIndex}`;
        urlPath = urlPath.replace('{languageCode}', encodeURIComponent(String(requestParameters['languageCode'])));
        urlPath = urlPath.replace('{categoryId}', encodeURIComponent(String(requestParameters['categoryId'])));
        urlPath = urlPath.replace('{pageIndex}', encodeURIComponent(String(requestParameters['pageIndex'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Products
     */
    async productsGetProductsRaw(requestParameters: ProductsGetProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductsResponseGetProductsResponse>> {
        const requestOptions = await this.productsGetProductsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get Products
     */
    async productsGetProducts(requestParameters: ProductsGetProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductsResponseGetProductsResponse> {
        const response = await this.productsGetProductsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for productsGetProductsWithoutOptionalParameter without sending the request
     */
    async productsGetProductsWithoutOptionalParameterRequestOpts(requestParameters: ProductsGetProductsWithoutOptionalParameterRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['languageCode'] == null) {
            throw new runtime.RequiredError(
                'languageCode',
                'Required parameter "languageCode" was null or undefined when calling productsGetProductsWithoutOptionalParameter().'
            );
        }

        if (requestParameters['categoryId'] == null) {
            throw new runtime.RequiredError(
                'categoryId',
                'Required parameter "categoryId" was null or undefined when calling productsGetProductsWithoutOptionalParameter().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/products/{languageCode}/{categoryId}`;
        urlPath = urlPath.replace('{languageCode}', encodeURIComponent(String(requestParameters['languageCode'])));
        urlPath = urlPath.replace('{categoryId}', encodeURIComponent(String(requestParameters['categoryId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Products without optional parameter
     */
    async productsGetProductsWithoutOptionalParameterRaw(requestParameters: ProductsGetProductsWithoutOptionalParameterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductsResponseGetProductsResponse>> {
        const requestOptions = await this.productsGetProductsWithoutOptionalParameterRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get Products without optional parameter
     */
    async productsGetProductsWithoutOptionalParameter(requestParameters: ProductsGetProductsWithoutOptionalParameterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductsResponseGetProductsResponse> {
        const response = await this.productsGetProductsWithoutOptionalParameterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for productsGetPromotedProducts without sending the request
     */
    async productsGetPromotedProductsRequestOpts(requestParameters: ProductsGetPromotedProductsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['languageCode'] == null) {
            throw new runtime.RequiredError(
                'languageCode',
                'Required parameter "languageCode" was null or undefined when calling productsGetPromotedProducts().'
            );
        }

        if (requestParameters['pageIndex'] == null) {
            throw new runtime.RequiredError(
                'pageIndex',
                'Required parameter "pageIndex" was null or undefined when calling productsGetPromotedProducts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/products/promotions/{languageCode}/{pageIndex}`;
        urlPath = urlPath.replace('{languageCode}', encodeURIComponent(String(requestParameters['languageCode'])));
        urlPath = urlPath.replace('{pageIndex}', encodeURIComponent(String(requestParameters['pageIndex'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Promoted Products
     */
    async productsGetPromotedProductsRaw(requestParameters: ProductsGetPromotedProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductsResponseGetPromotedProductsResponse>> {
        const requestOptions = await this.productsGetPromotedProductsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get Promoted Products
     */
    async productsGetPromotedProducts(requestParameters: ProductsGetPromotedProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductsResponseGetPromotedProductsResponse> {
        const response = await this.productsGetPromotedProductsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for productsGetPromotedProductsWithoutOptionalParameter without sending the request
     */
    async productsGetPromotedProductsWithoutOptionalParameterRequestOpts(requestParameters: ProductsGetPromotedProductsWithoutOptionalParameterRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['languageCode'] == null) {
            throw new runtime.RequiredError(
                'languageCode',
                'Required parameter "languageCode" was null or undefined when calling productsGetPromotedProductsWithoutOptionalParameter().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/products/promotions/{languageCode}`;
        urlPath = urlPath.replace('{languageCode}', encodeURIComponent(String(requestParameters['languageCode'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Promoted Products without optional parameter
     */
    async productsGetPromotedProductsWithoutOptionalParameterRaw(requestParameters: ProductsGetPromotedProductsWithoutOptionalParameterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductsResponseGetPromotedProductsResponse>> {
        const requestOptions = await this.productsGetPromotedProductsWithoutOptionalParameterRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get Promoted Products without optional parameter
     */
    async productsGetPromotedProductsWithoutOptionalParameter(requestParameters: ProductsGetPromotedProductsWithoutOptionalParameterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductsResponseGetPromotedProductsResponse> {
        const response = await this.productsGetPromotedProductsWithoutOptionalParameterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for productsGetTopProducts without sending the request
     */
    async productsGetTopProductsRequestOpts(requestParameters: ProductsGetTopProductsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['languageCode'] == null) {
            throw new runtime.RequiredError(
                'languageCode',
                'Required parameter "languageCode" was null or undefined when calling productsGetTopProducts().'
            );
        }

        if (requestParameters['limit'] == null) {
            throw new runtime.RequiredError(
                'limit',
                'Required parameter "limit" was null or undefined when calling productsGetTopProducts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/products/top/{languageCode}/{limit}`;
        urlPath = urlPath.replace('{languageCode}', encodeURIComponent(String(requestParameters['languageCode'])));
        urlPath = urlPath.replace('{limit}', encodeURIComponent(String(requestParameters['limit'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Top Products
     */
    async productsGetTopProductsRaw(requestParameters: ProductsGetTopProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductsResponseGetTopProductsResponse>> {
        const requestOptions = await this.productsGetTopProductsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get Top Products
     */
    async productsGetTopProducts(requestParameters: ProductsGetTopProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductsResponseGetTopProductsResponse> {
        const response = await this.productsGetTopProductsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for productsGetTopProductsWithoutOptionalParameter without sending the request
     */
    async productsGetTopProductsWithoutOptionalParameterRequestOpts(requestParameters: ProductsGetTopProductsWithoutOptionalParameterRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['languageCode'] == null) {
            throw new runtime.RequiredError(
                'languageCode',
                'Required parameter "languageCode" was null or undefined when calling productsGetTopProductsWithoutOptionalParameter().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/products/top/{languageCode}`;
        urlPath = urlPath.replace('{languageCode}', encodeURIComponent(String(requestParameters['languageCode'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get Top Products without optional parameter
     */
    async productsGetTopProductsWithoutOptionalParameterRaw(requestParameters: ProductsGetTopProductsWithoutOptionalParameterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductsResponseGetTopProductsResponse>> {
        const requestOptions = await this.productsGetTopProductsWithoutOptionalParameterRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get Top Products without optional parameter
     */
    async productsGetTopProductsWithoutOptionalParameter(requestParameters: ProductsGetTopProductsWithoutOptionalParameterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductsResponseGetTopProductsResponse> {
        const response = await this.productsGetTopProductsWithoutOptionalParameterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for productsSearchProducts without sending the request
     */
    async productsSearchProductsRequestOpts(requestParameters: ProductsSearchProductsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['searchTerm'] == null) {
            throw new runtime.RequiredError(
                'searchTerm',
                'Required parameter "searchTerm" was null or undefined when calling productsSearchProducts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/products/search/{searchTerm}`;
        urlPath = urlPath.replace('{searchTerm}', encodeURIComponent(String(requestParameters['searchTerm'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Search Products
     */
    async productsSearchProductsRaw(requestParameters: ProductsSearchProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductsResponseSearchProductsResponse>> {
        const requestOptions = await this.productsSearchProductsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Search Products
     */
    async productsSearchProducts(requestParameters: ProductsSearchProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductsResponseSearchProductsResponse> {
        const response = await this.productsSearchProductsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
